import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from '../MaterialIcon/MaterialIcon';
import styles from './_benefits-section.module.scss';

function BenefitsSectionItem({ icon, description }) {
    return <li className={styles['benefits-section__item']}>
        <MaterialIcon
            className={styles['benefits-section__icon']}
            icon={icon}
            ariaHidden
        />
        <div className={styles['benefits-section__text']}>
            {description}
        </div>
    </li>;
}

BenefitsSectionItem.propTypes = {
    icon: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default BenefitsSectionItem;